import OptionChainToolActions from "@frameworks/web/redux/feature/Markets/Options/actions/OptionChainTool";
export default () => {
    return {
        search: {
            optionChainToolActions: new OptionChainToolActions(),
        },
    };
};
